import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SpeechinputmodalPage } from './speechinputmodal.page';

const routes: Routes = [
  {
    path: '',
    component: SpeechinputmodalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SpeechinputmodalPageRoutingModule {}
